const e = (t) => typeof Element > "u" ? !1 : t instanceof Element, a = (t) => {
  if (t.tabIndex > 0 || t.tabIndex === 0 && t.getAttribute("tabIndex") !== null)
    return !0;
  if (t.tabIndex < 0 || t.hasAttribute("disabled") || t.getAttribute("aria-disabled") === "true")
    return !1;
  switch (t.nodeName) {
    case "A":
      return !!t.href && t.rel !== "ignore";
    case "INPUT":
      return !(t.type === "hidden" || t.type === "file");
    case "BUTTON":
    case "SELECT":
    case "TEXTAREA":
      return !0;
    default:
      return !1;
  }
}, i = (t, u) => {
  if (!t || !t.focus) return;
  let r = !1;
  e(t) && !a(t) && !t.getAttribute("tabindex") && (t.setAttribute("tabindex", "-1"), r = !0), t.focus(u), e(t) && r && t.removeAttribute("tabindex");
};
export {
  i as focusElement,
  a as isFocusable
};
